import {ChangeDetectorRef, OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {formatDistanceToNow} from 'date-fns/esm';
import {parseToDate} from '../../shared/utils';
import fi from 'date-fns/locale/fi';
import {StateService} from '../../shared/state/state.service';
import {Subscription} from 'rxjs';
import {interval} from 'rxjs';

@Pipe({
  name: 'qmDateDistance',
  pure: false
})
export class QmDateDistancePipe implements PipeTransform, OnDestroy {
  private refresher: Subscription = new Subscription();

  constructor(private state: StateService, private cdRef: ChangeDetectorRef) {
    this.refresher = interval(10000).subscribe((val) => {
      this.cdRef.detectChanges();
    });
  }

  ngOnDestroy() {
    this.refresher.unsubscribe();
  }

  transform(value: Date | string | number): string {
    const options: any = { addSuffix: true };
    if (this.state.getPartOfState('settingsState').language === 'fi') {
      options.locale = fi;
    }
    return formatDistanceToNow(parseToDate(value), options);
  }


}
